<template>
  <vertical-modal width="tn" :visible="visible" @close="close"
                  body-class="tw-p-6"
                  header-title="افزودن حساب بانکی">
    <template #body>

      <input-ayandeh icon-on-input="person"
                     body-class="tw-mb-4"
                     floatLabel="نام و نام خانوادگی"
                     placeholder="نام و نام خانوادگی صاحب حساب"
                     v-model:value="fullname" />

      <input-ayandeh icon-on-input="credit-card"
                     body-class="tw-mb-4"
                     floatLabel="شماره کارت"
                     placeholder="شماره کارت را وارد کنید"
                     v-mask="'#### #### #### ####'"
                     v-model:value="credit_card" />

      <input-ayandeh icon-on-input="key-visualizer"
                     body-class="tw-mb-4"
                     floatLabel="شماره شبا"
                     placeholder="شماره شبا را وارد کنید"
                     v-mask="'IR## #### #### #### #### #### ##'"
                     v-model:value="shaba_num" />

    </template>

    <template #footer>
      <new-btn variant="outline"
               color="primary"
               @click="close">بستن
      </new-btn>
      <new-btn variant="outline"
               color="primary"
               :disabled="form_completed === false"
               :loading="loading"
               @click="store_bank_information">
        <base-icon icon="save" class="tw-ml-2 tw-align-middle" />
        ذخیره
      </new-btn>
    </template>
  </vertical-modal>

</template>

<script setup>

import { ref, computed, getCurrentInstance, watch , defineProps} from 'vue'
import VerticalModal from "@/components/base/VerticalModal.vue";
import NewBtn from "@/components/base/btn/NewBtn.vue";
import BaseSelect from "@/components/base/select/BaseSelect.vue";
import InputAyandeh from "@/components/inputs/InputAyandeh.vue";
import BaseIcon from "@/components/base/BaseIcon.vue";
import { apiStoreUpdateBankInformation } from '@/services/bank/BankInformation';

const fullname = ref('')
const credit_card = ref('')
const shaba_num = ref('')
const loading = ref(false)
const proxy = getCurrentInstance().proxy

const props = defineProps({
  visible: { type: Boolean, default: false },
  payment_able_id: { type: [String, Number, null]},
  other_sanad_id: { type: [String, Number, null]},
  bank_information: { type: Object, default: null },
})

const form_completed = computed(() => {
  return !!fullname.value &&
    !!credit_card.value &&
    credit_card.value.replaceAll(' ', '').length === 16 &&
    (shaba_num.value.length && shaba_num.value.replaceAll(' ', '').length === 26)
})

const emit = defineEmits(['close', 'updatedBank'])

const close = () => {
  resetFormData()
  emit('close', true)
}

const resetFormData = () => {
  fullname.value = ''
  credit_card.value = ''
  shaba_num.value = ''
}

const store_bank_information = async () => {

  try {
    loading.value = true

    let response = await apiStoreUpdateBankInformation({
      bank_information_id: props.bank_information?.id || null,
      payment_able_id: props.payment_able_id || '',
      other_sanad_id: props.other_sanad_id || '',
      owner_name: fullname.value,
      credit_card: credit_card.value.replaceAll(' ', ''),
      shaba_num: shaba_num.value.replaceAll(' ', ''),
    })

    if(!response) return

    const data = response.data
    if(data?.status === 'success') {
      proxy.$toast(data.message, 'success')
      emit('updatedBank', data.bank_information)
      close()
    }
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false
  }
}

watch(
  () => props.visible,
  (newVal) => {
    if(newVal && props.bank_information) {
      alert(newVal)
      fullname.value = props.bank_information.owner_name || ''
      credit_card.value = props.bank_information.credit_card || ''
      shaba_num.value = props.bank_information.shaba_num || ''
    }
  }
)


</script>
<style scoped>

</style>
